import classNames from 'classnames'
import { joinStringWithDashes } from '@helpers/utils'
import styles from './styles.module.scss'

type BulletProps = {
  unknown?: boolean
  disabled?: boolean
  isSelected?: boolean
  classes?: string

  /**
   * New preferred callback for controlled usage (react-hook-form, etc.)
   */
  onChange?: (value: string) => void

  /**
   * Legacy callback for existing callers.
   * If `onChange` is provided, it will be used instead.
   */
  changeValue?: (arg: Record<string, string>) => void

  label: string
  value: string
  id: string
  variant?: 'round' | 'square'
}

function Bullet({
  value,
  id,
  onChange,
  changeValue,
  unknown = false,
  label,
  classes = '',
  disabled = false,
  isSelected = false,
  variant = 'round'
}: BulletProps) {
  const handleClick = () => {
    if (disabled) return

    if (onChange) {
      onChange(value)
    } else if (changeValue) {
      // backwards compatible behaviour
      changeValue({ [id]: value })
    }
  }

  const bulletClassNames = classNames(
    styles.button__item,
    {
      [styles.active]: isSelected,
      [styles.unknown]: unknown
    },
    styles[variant],
    classes
  )

  return (
    <button
      className={bulletClassNames}
      disabled={disabled}
      type="button"
      onClick={handleClick}
      value={label}
      id={`${joinStringWithDashes(id)}-${joinStringWithDashes(value)}`}
    >
      <span className={styles.radio__box}>{label}</span>
    </button>
  )
}

export default Bullet
